module.exports = "https://www.gc-pro.gnp.com.mx/7f06d32c94f4df3f84637389ba7c1a76.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon_autos_off.svg
// module id = 689
// module chunks = 0